import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Nexus from "../../assets/trainers/icon-nexus.png";

export default function ExamplesTrainers() {
	const { t } = useTranslation();
	const primaryColor = "#43BD98";
	const accentColor = "#4A90E2";

	const examples = t("trainer.examples.items", { returnObjects: true });

	return (
		<section
			id="ejemplos"
			style={{
				padding: "6rem 2rem",
				backgroundColor: "#f8fbfa",
				fontFamily: "'Poppins', sans-serif",
				textAlign: "center",
				scrollMarginTop: "100px",
			}}
		>
			{/* Encabezado */}
			<motion.div
				initial={{ opacity: 0, y: 30 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
				viewport={{ once: true }}
				style={{ marginBottom: "3rem" }}
			>
				<p
					style={{
						color: accentColor,
						fontSize: "0.9rem",
						fontWeight: 600,
						letterSpacing: "1px",
						textTransform: "uppercase",
						marginBottom: "0.5rem",
					}}
				>
					{t("trainer.examples.badge")}
				</p>
				<h2
					style={{
						fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
						color: "#1a1a1a",
						fontWeight: 800,
						margin: 0,
					}}
					dangerouslySetInnerHTML={{ __html: t("trainer.examples.title") }}
				/>
			</motion.div>

			{/* Tarjetas */}
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					flexWrap: "wrap",
					gap: "2rem",
				}}
			>
				{examples.map((example, index) => (
					<motion.div
						key={index}
						initial={{ opacity: 0, y: 40 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: index * 0.2 }}
						viewport={{ once: true, amount: 0.3 }}
						whileHover={{
							y: -6,
							scale: 1.03,
							boxShadow:
								"0 15px 45px rgba(67,189,152,0.25), 0 0 0 1px rgba(67,189,152,0.1)",
							transition: { duration: 0.3 },
						}}
						style={{
							width: "300px",
							backgroundColor: "#fff",
							borderRadius: "16px",
							boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
							overflow: "hidden",
							border: "1px solid rgba(67,189,152,0.25)",
						}}
					>
						<img
							src={Nexus}
							alt={example.name}
							style={{
								width: "100%",
								display: "block",
								height: "200px",
								objectFit: "cover",
							}}
						/>
						<div style={{ padding: "1.5rem" }}>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									gap: "0.6rem",
								}}
							>
								{/* Fila con Play y App Store */}
								<div
									style={{
										display: "flex",
										justifyContent: "center",
										gap: "0.8rem",
									}}
								>
									<a
										href={example.androidLink}
										target="_blank"
										rel="noopener noreferrer"
										style={{
											backgroundColor: accentColor,
											color: "white",
											padding: "0.5rem 1rem",
											borderRadius: "8px",
											fontSize: "0.85rem",
											textDecoration: "none",
											fontWeight: 500,
										}}
									>
										<i
											className="fa-brands fa-google-play"
											style={{ marginRight: 6 }}
										/>
										{t("trainer.examples.play")}
									</a>
									<a
										href={example.iosLink}
										target="_blank"
										rel="noopener noreferrer"
										style={{
											border: `2px solid ${accentColor}`,
											color: accentColor,
											padding: "0.5rem 1rem",
											borderRadius: "8px",
											fontSize: "0.85rem",
											textDecoration: "none",
											fontWeight: 500,
										}}
									>
										<i
											className="fa-brands fa-apple"
											style={{ marginRight: 6 }}
										/>
										{t("trainer.examples.appstore")}
									</a>
								</div>

								{/* Botón Reservas Online */}
								<a
									href={example.bookingLink}
									target="_blank"
									rel="noopener noreferrer"
									style={{
										border: `2px solid ${primaryColor}`,
										color: primaryColor,
										padding: "0.5rem 1rem",
										borderRadius: "8px",
										fontSize: "0.85rem",
										textDecoration: "none",
										fontWeight: 500,
										alignSelf: "center",
										minWidth: "140px",
										marginTop: "0.3rem",
									}}
								>
									<i
										className="fa-regular fa-calendar-check"
										style={{ marginRight: 6 }}
									/>
									{t("trainer.examples.booking")}
								</a>
							</div>
						</div>
					</motion.div>
				))}
			</div>
		</section>
	);
}
